<template>
	<div class="records-page">
		<div class="records-page-t">
			<h5 class="records-page-title">继续搜索</h5>
			<p class="records-page-desc">您可以接着上次搜索的进度继续查找所需的内容</p>
		</div>
		<div class="records-page-b ">
			<p class="records-page-b-title">搜索记录</p>
			<div 
				class="records-page-enum fine-scroll-bar"
				v-infinite-scroll="loadSearchRecords"
				:infinite-scroll-distance="1"
				:infinite-scroll-disabled="isFinalPage"
			>
				<ul class="records-page-ul">
					<li
						v-for="item in searchRecordList"
						:key="item.id"
						class="records-page-li"
					>
						<p class="records-page-li-time">{{ item.searchTime | handleFormatDateAndTimeNoYear }}</p>
						<div class="records-page-li-b">
							<ul class="records-page-li-b-l">
								<li 
									v-for="(tag, tagIndex) in item.tags"
									:key="tagIndex"
									class="records-page-li-b-l-list"
								>{{ tag }}</li>
							</ul>
							<el-button
								@click="fastSearch(item.searchCondition)"
								class="records-page-li-b-r"
								size="small"
							>搜索</el-button>
						</div>
					</li>
					<li v-if="searchRecordsLoading" class="records-page-loading" v-loading="true"></li>
					<li v-if="isFinalPage && searchRecordList.length >= 10" class="records-page-loading">到底了~</li>
				</ul>
			</div>
		</div>
	</div>
</template>

<script>
import { buyerSearchHistory } from "@/utils/api/seamark"

export default {
	name: 'records-page',
	props: ['firstPageList'],
	data() {
		return {
			searchRecordsLoading: false,  //搜索记录时的loading
			searchRecordList: [],	//搜索记录列表
			finalId: null,
			finalSearchTime: null,
			isFinalPage: false,	//是否最后一页，禁用滚动加载
		}
	},
	methods: {
		loadSearchRecords() {
			this.buyerSearchHistory();
    },
		async buyerSearchHistory() {
			if(this.searchRecordsLoading) return;
			this.searchRecordsLoading = true;
			const params = {
				type: 1,	// 1搜索历史 2被保存的搜索
				id: this.finalId, //向下滚动: id取上次结果的最后一条id;  向上滚动: id取上次结果的第一条。(第1页就为空)
				searchTime: this.finalSearchTime,
				pageSize: 10,	//接口默认10
			}
			try {
				const res = await buyerSearchHistory(params);
				this.searchRecordsLoading = false;
				if(res.rspResult.bizCode==200){
					const _list = res.rspListData.list || [];
					if(params.id) {
						// 表示非第一页
						this.searchRecordList = this.searchRecordList.concat(_list);
					}else {
						// 第一页
						this.searchRecordList = _list;
					}
					if(_list && _list.length) {
						this.finalId = _list[_list.length - 1].id;
						this.finalSearchTime = _list[_list.length - 1].searchTime;
					}else {
						this.isFinalPage = true;
					}
				}else{
					this.$message.error(res.rspResult.message);
				}
			} catch (err) {
				this.searchRecordsLoading = false;
				console.error('获取海外采购搜索记录的保存出错', err)
			}

		},
		fastSearch(condition) {
			this.$emit('fastSearch', condition)
			// this.$emit('hideSelf')
		},
	},
	created() {
		this.searchRecordList = [...this.firstPageList];
		if(this.searchRecordList.length) {
			this.finalId =  this.searchRecordList[this.searchRecordList.length - 1].id;
			this.finalSearchTime =  this.searchRecordList[this.searchRecordList.length - 1].searchTime;
		}
	},
	// beforeDestroy() {
	// 	this.$emit('beforeDestroy')
	// },
}
</script>

<style lang="scss" scoped>
.records-page {
	margin-left:12px;
	// background: #FFFFFF;
	height: 100%;
	&-t {
		padding-top: 30px;
		text-align: center;
		margin-bottom: 30px;
		.records-page-title {
			height: 18px;
			line-height: 18px;
			font-family: SourceHanSansCN-Bold;
			font-weight: 700;
			font-size: 18px;
			color: #16181A;
			letter-spacing: 0;
			margin-bottom: 12px;
		}
		.records-page-desc {
			height: 14px;
			line-height: 14px;
			font-family: SourceHanSansCN-Regular;
			font-weight: 400;
			font-size: 14px;
			color: #4F5D78;
			letter-spacing: 0;
		}
	}
	&-b {
		padding: 0 34px 0 40px;
		background-clip: content-box;
		&-title {
			height: 14px;
			line-height: 14px;
			font-family: SourceHanSansCN-Medium;
			font-weight: 500;
			font-size: 14px;
			color: #16181A;
			margin-bottom: 20px;
		}
		.records-page-enum {
			overflow-y: auto;
			height: calc(100vh - 253px);
			.records-page-ul {
				width: calc(100% - 6px);
				.records-page-li {
					box-sizing: border-box;
					padding: 16px 20px 8px;
					// height: 90px;
					background: #fff;
					border-radius: 4px;
					margin-bottom: 12px;
					&:nth-last-child(1) {
						margin-bottom: 0;
					}
					&-time {
						height: 14px;
						line-height: 14px;
						font-family: SourceHanSansCN-Regular;
						font-weight: 400;
						font-size: 14px;
						color: #16181A;
						margin-bottom: 14px;
					}
					&-b {
						position: relative;
						&-l {
							display: flex;
							flex-wrap: wrap;
							padding-top: 2px;
							max-width: calc(100% - 88px);
							min-height: 35px;
							&-list {
								padding: 0 16px;
								// height: 28px;
								background: #F5F7FA;
								// border: 1px solid #E5E8ED;
								border-radius: 4px;
								line-height: 26px;
								font-family: SourceHanSansCN-Regular;
								font-weight: 400;
								font-size: 14px;
								color: #16181A;
								margin-right: 8px;
								margin-bottom: 8px;
								// user-select: none;
								&:nth-last-child(1) {
									margin-right: 0;
								}
							}
						}
						&-r {
							position: absolute;
							right: 0;
							bottom: 6px;
							width: 68px;
							font-family: SourceHanSansCN-Medium;
							font-weight: 500;
							font-size: 14px;
							color: #066EB7;
							border: 0;
							background: rgba(6, 110, 183, 0.1);
							&:hover {
								background: rgba(6, 110, 183, 0.2);
							}
						}
					}
				}
			}
		}
	}
}

// 加载更多
::v-deep .records-page-loading {
	line-height: 30px;
	font-family: SourceHanSansCN-Regular;
	font-size: 14px;
	color: #4F5D78;
	text-align: center;

	height: 30px;
	margin-top: 10px;
	.el-loading-mask {
		overflow: hidden;
		.el-loading-spinner {
			margin-top: 0;
			top: 0;
			height: 30px;
			.circular {
				width: 30px;
				height: 30px;
			}
		}
	}
}
</style>